<template>
    <div class="home-itemlist">
        <div class="head-title">
            <h4>{{item.name}}</h4>
            <i>{{$t('b_operator')}}{{item.gid}}</i>
        </div>
        <div class="head-content">
            <div class="img">
                <img src="@/images/temporary/group.jpg">
            </div>
            <div class="echart">
                <div class="oee">
                    <p class="tx">OEE</p>
                    <p class="val">{{run}}</p>
                </div>
                <div ref="echart" style="width:120px;height:120px;"></div>
            </div>
            <div class="info">
                <div>
                    <div class="item">
                        <Icon type="md-pie" size="16" style="color:#009900;"/>
                        <label>{{$t('run')}}</label>
                        <span>
                            <span>{{run}}(</span>
                            <b>{{item.run_count}}</b>)
                        </span>
                    </div>
                    <div class="item">
                        <Icon type="md-pie" size="16" style="color:#C6C013;"/>
                        <label>{{$t('stby')}}</label>
                        <span>
                            <span>{{stby}}(</span>
                            <b>{{item.stby_count}}</b>)
                        </span>
                    </div>
                    <div class="item">
                        <Icon type="md-pie" size="16" style="color:#EF2917;"/>
                        <label>{{$t('alarm')}}</label>
                        <span>
                            <span>{{alarm}}(</span>
                            <b>{{item.alarm_count}}</b>)
                        </span>
                    </div>
                    <div class="item">
                        <Icon type="md-pie" size="16" style="color:#898989;"/>
                        <label>{{$t('stop')}}</label>
                        <span>
                            <span>{{stop}}(</span>
                            <b>{{item.stop_count}}</b>)
                        </span>
                    </div>
                </div>
            </div>
            <div class="count">
                <div class="item">
                    <p class="tx">{{$t('useRate')}}</p>
                    <p class="val">{{run}}</p>
                </div>
                <div class="item">
                    <p class="tx">{{$t('powerNum')}}</p>
                    <p class="val">{{kwh}}</p>
                </div>
                <div class="item">
                    <p class="tx">{{$t('finishNum')}}</p>
                    <p class="val">{{item.finish}}/{{item.total}}</p>
                </div>
                <div class="item">
                    <p class="tx">{{$t('finishRate')}}</p>
                    <p class="val">{{finish}}</p>
                </div>
            </div>
            <div class="btns">
                <Button type="info" class="margin-r10" @click="toOeeTable(item.gid)">{{$t('oeeReport')}}</Button>
                <Button type="info" @click="toGroupInfo(item.gid)">{{$t('groupInfo')}}</Button>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts';
export default {
    props: { item: Object },
    data() {
        return {
            myChart: {},
            // 图表配置
            options: {
                color: ['#009900', '#C6C013', '#EF2917', '#898989', '#eeeeee'], // 主题色
                series: [
                    {
                        name: 'OEE',
                        type: 'pie',
                        radius: ['30%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            }
                        },
                        data: [{ value: 0, name: this.$t('run') }, { value: 0, name: this.$t('stby') }, { value: 0, name: this.$t('alarm') }, { value: 0, name: this.$t('stop') }, { value: 0, name: this.$t('off') }]
                    }
                ]
            }
        };
    },
    computed: {
        run() {
            let total = this.item.run + this.item.stby + this.item.alarm + this.item.stop + this.item.off;
            if (total > 0) {
                return ((this.item.run / total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        stby() {
            let total = this.item.run + this.item.stby + this.item.alarm + this.item.stop + this.item.off;
            if (total > 0) {
                return ((this.item.stby / total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        alarm() {
            let total = this.item.run + this.item.stby + this.item.alarm + this.item.stop + this.item.off;
            if (total > 0) {
                return ((this.item.alarm / total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        stop() {
            let total = this.item.run + this.item.stby + this.item.alarm + this.item.stop + this.item.off;
            if (total > 0) {
                return ((this.item.stop / total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        off() {
            let total = this.item.run + this.item.stby + this.item.alarm + this.item.stop + this.item.off;
            if (total > 0) {
                return ((this.item.off / total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        finish() {
            if (this.item.total > 0) {
                return ((this.item.finish / this.item.total) * 100).toFixed(1) + '%';
            }
            return '0.0%';
        },
        kwh() {
            if (this.item.power > 0) {
                return (this.item.power / 10).toFixed(1) + 'kwh';
            }
            return '0.0kwh';
        }
    },
    mounted() {
        let dom = this.$refs.echart;
        this.myChart = echarts.init(dom);
        this.options.series[0].data[0].value = this.item.run;
        this.options.series[0].data[1].value = this.item.stby;
        this.options.series[0].data[2].value = this.item.alarm;
        this.options.series[0].data[3].value = this.item.stop;
        this.options.series[0].data[4].value = this.item.off;
        this.myChart.setOption(this.options, true);
    },
    methods: {
        toOeeTable(gid) {
            if (this.item.main_uuid == '') {
                this.$Message.warning(this.$t('b_noZhuSuJi'));
            } else {
                // this.$router.replace({ path: `/oeetable/${gid}` });
                this.$router.push({ path: `/oeetable/${gid}` });
            }
        },
        toGroupInfo(gid) {
            this.$router.push({ path: `/group/${gid}` });
        }
    },
    beforeUpdate() {
        this.options.series[0].data[0].value = this.item.run;
        this.options.series[0].data[1].value = this.item.stby;
        this.options.series[0].data[2].value = this.item.alarm;
        this.options.series[0].data[3].value = this.item.stop;
        this.options.series[0].data[4].value = this.item.off;
        this.myChart.setOption(this.options);
    }
};
</script>
<style lang="less">
.home-itemlist {
    .head-title {
        display: flex;
        justify-content: space-between;
        padding: 10px 10px 5px 10px;
        border-bottom: 1px solid #e3e3e3;
        h4 {
            flex: 1;
            font-size: 16px;
        }
        i {
            font-size: 16px;
            font-weight: bolder;
        }
    }
    .head-content {
        padding: 10px;
        display: flex;
        align-items: center;
        .img {
            padding-left: 30px;
            width: 115px;
            height: 85px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .echart {
            display: flex;
            height: 120px;
            align-items: center;
        }
        .oee {
            flex: 1;
            padding: 0 40px;
            .tx {
                font-size: 12px;
                font-weight: bold;
            }
            .val {
                font-size: 30px;
            }
        }
        .info {
            padding: 0 40px;
            display: flex;
            align-items: center;
            width: 400px;
            .item {
                float: left;
                display: flex;
                align-items: center;
                width: 50%;
                height: 35px;
                font-size: 14px;
                padding: 0 15px;
                label {
                    padding-left: 8px;
                }
                span {
                    flex: 1;
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
        .count {
            display: flex;
            align-items: center;
            margin-left: 40px;
            .item {
                text-align: center;
                padding: 0 30px;
                border-left: 1px solid #e3e3e3;
                .tx {
                    font-size: 20px;
                    color: #777;
                }
                .val {
                    font-size: 20px;
                    font-weight: bold;
                }
            }
        }
        .btns {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 30px;
            button {
                width: 100px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/home/components/itemList.vue